export enum NoteBoxSource {
  NOTA = 'NOTA',
  COMENTARIO = 'COMENTARIO'
}
